import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "./constants";

export function* getLocizeMessage({ locale, locizeApi }) {
  try {
    const result = yield call(locizeApi, locale);
    yield put({
      type: types.GET_LOCIZE_MESSAGE_SUCCESS,
      data: result,
      locale
    });
  } catch (error) {
    yield put({
      type: types.GET_LOCIZE_MESSAGE_FAILURE,
      data: error
    });
  }
}

export function* fetchSupportedLocales({supportedLocalesApi}) {
  try {
    const result = yield call(supportedLocalesApi);
    if(result instanceof Error || !Array.isArray(result)) {
      yield put({
        type: types.GET_SUPPORTED_LOCALES_FAILURE,
      });
    }else{
      yield put({
        type: types.GET_SUPPORTED_LOCALES_SUCCESS,
        data: result,
      });
    }
  } catch (error) {
    yield put({
      type: types.GET_SUPPORTED_LOCALES_FAILURE,
    });
  }
}

export function* watchForFetchSupportedLocales() {
  yield takeLatest(types.GET_SUPPORTED_LOCALES_REQUEST, fetchSupportedLocales);
}

export function* watchGetLocizeMessage() {
  yield takeLatest(types.GET_LOCIZE_MESSAGE_REQUEST, getLocizeMessage);
}

export default [watchGetLocizeMessage, watchForFetchSupportedLocales];
